/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import  { Suspense,useContext,useEffect,useState,useCallback } from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import React from 'react';
import {logout,setUserType,verifyOtp} from '../pages/auth/authSlice'
// import {CognitoCurrentData,CognitoData} from '../CommonMethods/CognitoData'
import {Route,Navigate,Routes,useNavigate,useLocation} from 'react-router-dom';
import GlobalContext from '../components/Context/GloablContext';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import Layout from '../components/Layout'
import SideBar from '../components/Layout/Sidebar';
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import Profile from '../pages/Profile';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import TrustBrowser from '../pages/auth/LoginForm/Components/TrustBrowser';
import UpdatePassword from '../pages/auth/LoginForm/Components/UpdatePassword';
import PageNotFound from '../pages/auth/LoginForm/Components/PageNotFound';
import Home from '../pages/auth/LoginForm/Components/Home';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification';
import { handleEditMessageSent,handleTargetUserEditId } from '../redux/systemConfigSlice';
import Noroute from '../components/Noroutes/Noroutes';
import CustomOverLay from '../components/CustomOverLay';

export default function NavigationRoutes(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setloading] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const userType = sessionStorage.getItem('user_type');
    const rolesToMap = ComponentsBasedOnRole[userType];
    const [isAuthenticating, setIsAuthenticating] =useState(true)
    const {editSocket,setEditSocket}=useContext(GlobalContext)



    const restrictroute = useSelector(state=>state?.systemConfigData?.restrict)
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)


    useEffect(()=> {
        if(sessionStorage.getItem('IdToken')  !== null){
            setIsLoggedIn(true);
            setIsAuthenticating(false);
            if(sessionStorage.getItem('custom:is_first_time_login')==="true"){
                navigate('/reset')
            }else if(location.pathname === '/reset'){
                navigate('/profile')
            }
            
        }
        else{
            setIsLoggedIn(false);
            setIsAuthenticating(false)
        }
    }, [location])

    useEffect(()=>{
        const editRoutes = ['/manage-patients/edit-patient/:id']
        if(!editRoutes.includes(location.pathname)&&(editingUserId!==''||messageSent===true)){
        }

    },[])

    return (

        <Suspense fallback={<div></div>}>{
            <>
                {
                    isAuthenticating  ? <div><CustomOverLay Active text="Loading ARCM Provider/Monitor Web Application" classKey="fixed top-0 left-0 right-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center text-white"/></div> :
                        (<Routes location={location} key={location.pathname}>
                            <Route path="/email-address-verification" element={
                                <AnimatedPage>
                                    <EmailVerificationScreen />
                                </AnimatedPage>
                            }/>
                            {!isLoggedIn ? 
                                <>
                                    <Route path="/" element={
                                        <AnimatedPage><LoginPage /></AnimatedPage>} />
                                    <Route path="/reset" element={
                                        <AnimatedPage>
                                            <ResetPassword />
                                        </AnimatedPage>
                                    } />
                                    <Route path="/reset-new-password" element={
                                        <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />
                                    <Route path="/404" element={
                                        <>
                                            <SearchEmptyScreen text={"404"} />
                                        </>} /> 
                                    <Route
                                        path="*"
                                        element={<PageNotFound/>} />
                            
                                </>
                                :
                                <>

                                    <Route path="/" element={
                                        <AnimatedPage><Home /></AnimatedPage>} />

                                    
                                    <Route path="/reset" element={
                                        <AnimatedPage>
                                            <ResetPassword />
                                        </AnimatedPage>
                                    } />
                                    <Route  element={<Layout {...props}/>}>
                                        {
                                            rolesToMap !== undefined && rolesToMap.map((nav) => (
                                                <Route 
                                                    path={nav.path} 
                                                    element={
                                                        (restrictroute === 'true' || restrictroute === true) && nav.roleKey !== 'Profile' ? (
                                                            nav.roleKey === 'UpdatePassword' ? (
                                                                React.cloneElement(nav.element, props)
                                                            ) : (
                                                                <Navigate to="/profile" />
                                                            )
                                                        ) : (
                                                            React.cloneElement(nav.element, props)
                                                        )
                                                    }
                                                    key={nav.path} 
                                                />
                                            ))
                                        }
                                    </Route>
                                    <Route
                                        path="*"
                                        element={<Navigate replace to="/" />} 
                                    />
                            
                                </>
                            }
                            <Route
                                path="*"
                                element={
                                    <Noroute/>
                                } 
                            />
                        </Routes>)}
            </>
        }</Suspense>

    );
}